<template lang="pug">
  el-card.box-card(shadow="always")
    .clearfix(slot='header')
      span Προσθήκη
      span(v-if="['Admin', 'RegistryAdmin'].includes(activeRole)") /Τροποποίηση
      span : Νέου Πανεπιστημίου
      el-button(style='float: right; padding: 5px 5px; margin: 10px 10px;', type='text',
        v-show='addUniversity'  @click="hideForm") Κλείσιμο
    .text.item
      el-form(:inline='true', :inline-message="true", label-width='130px', size='small', v-loading="deletingUnit")
        // Operation mode (Add/Modify)
        el-form-item(label="Λειτουργία", v-if="['Admin', 'RegistryAdmin'].includes(activeRole)")
          el-switch(v-model="addOrModify" active-text="Προσθήκη" inactive-text="Τροποποίηση"
            @change='addOrModifyChanged')
        br(v-show='!addOrModify')
        el-form-item(label="Τροποποίηση σε", v-show='!addOrModify', v-if="['Admin', 'RegistryAdmin'].includes(activeRole)")
          el-checkbox-group(v-model="checkboxΙnstitutions" @change='groupChanged')
            el-checkbox-button(v-for="institution in institutions" :label="institution" :key="institution") {{institution}}
        // Meetings
        el-form-item(label='Προσθήκη Συνεδρίας', prop='meeting', v-show='addOrModify', v-if="['Admin', 'RegistryAdmin'].includes(activeRole)")
          el-checkbox(v-model='addMeeting', @change='addMeetingChanged')
        br
        el-form-item(label='Αρ. Συνεδρίας', prop="meeting", v-loading='gettingMeetings'
          v-show="!addOrModify && checkboxΙnstitutions[0] === 'Συνεδρία'")
          el-select.big(v-model='meeting' , value-key="id", placeholder='Όνομα Συνεδρίας',
            filterable, clearable, @change='meetingSelected')
            el-option(v-for="meeting in meetings", :key="meeting.id",
              :label="meeting.meeting_no", :value="meeting")
        el-card.box-card(shadow="always", v-loading='gettingMeeting',
          v-show="addMeeting || (!addOrModify && checkboxΙnstitutions[0] === 'Συνεδρία')")
          .clearfix(slot='header')
            span(v-if='addOrModify') Εισάγετε νέα Συνεδρία
            span(v-else) Επιλέξτε και Τροποποιήστε την Συνεδρία {{meeting.meeting_no}}
          .text.item(v-loading='savingMeeting')
            el-form-item(label='Αρ. Συνεδρίας*', prop="meeting.meeting_no")
              el-input.big(type="text", placeholder='Συνεδρία', v-model='meeting.nameInserted',
              @input="meeting.nameInserted = meeting.nameInserted.toUpperCase()")
            el-form-item(label='Ημερομηνία Συνεδρίας*', prop="meeting.meeting_date")
              el-date-picker(v-model="meeting.meeting_date", type="date", placeholder="Ημερομηνία Συνεδρίας",
                format="dd-MM-yyyy", value-format="dd-MM-yyyy")
            el-form-item(label='Τύπος Συνεδρίας*', prop="meeting.ds_epitropi")
              el-select.big(v-model='meeting.ds_epitropi', value-key="id", placeholder='Τύπος Συνεδρίας',
                filterable, clearable)
                el-option(v-for="epi in dsEpitropes", :key="epi.key", :label="epi.label",
                  :value="epi.value")
            el-form-item(label='Αρμοδιότητα*', prop="meeting.resp_id")
              el-select.big(v-model='meeting.resp_id', value-key="id", placeholder='Αρμοδιότητα',
                filterable, clearable)
                el-option(v-for="resp in respId", :key="resp.key", :label="resp.label",
                  :value="resp.value")
        // Country Management
        el-form-item(label='Χώρα', v-loading="gettingCountries", prop="country", v-show="showAll.country && !addMeeting")
          el-select.countries(
            v-model='country',
            @change="countrySelected",
            @focus='getCountries'
            value-key="id",
            placeholder='Χώρα',
            filterable, clearable)
            el-option(v-for="country in countries",
              :key="country.id",
              :label="country.name",
              :value="country")
            el-option(v-show='addOrModify && activeRole !== "RegistryAdmin"', :label='otherValue.name', :value='otherValue', :key="otherValue.name")
        el-card.box-card(shadow="always", v-loading='savingCountry || gettingCountry',
          v-show="(country.name === 'Άλλο'|| (!addOrModify && checkboxΙnstitutions[0] === 'Χώρα')) && !addMeeting")
          .clearfix(slot='header')
            span(v-if='addOrModify') Εισάγετε νέα Χώρα
            span(v-else) Επιλέξτε και Τροποποιήστε την Χώρα {{country.name}}
          .text.item(v-show="showAll.country && !isEmptyValue(country.name)")
            el-form-item(label='Όνομα*'  prop="country.nameInserted")
              el-input.big(placeholder='Όνομα*', v-model='country.nameInserted',
                @input="country.nameInserted = country.nameInserted.toUpperCase()",
                @change="countryInsertedChanged")
            el-form-item(label='Συντομογραφία', prop='country.short_name')
              el-input(placeholder='Συντομογραφία', v-model='country.short_name',
                @input="country.short_name = country.short_name.toUpperCase()")
            el-tooltip(placement='right')
              div(slot='content')
                | Μέχρι 4 χαρακτήρες με βάση αυτό: https://www.nationsonline.org/oneworld/country_code_list.htm
              i.el-icon-question
            el-form-item(label='Προηγ. Όνομα', prop='country.ex_name')
              el-input(placeholder='Προηγούμενο Όνομα', v-model='country.ex_name',
                @input="country.ex_name = country.ex_name.toUpperCase()")
            el-form-item(label='Έχει πολιτείες', prop='states_exist')
              el-checkbox(v-model='states_exist' @change="statesExistsChanged")
            hr(v-show='!addOrModify')
            // City Management
            el-form-item(label="Διαχείριση Πόλεων", v-show='!addOrModify')
              el-switch(v-model="manageCities", active-text="Ναι",inactive-text="Όχι", @change='manageCitiesChanged')
              el-form-item(label='Επιλέξτε Πόλη', v-show='manageCities', v-loading='gettingCities')
                el-select.big(v-model='city' , @change="cityForCountrySelected", value-key="id", placeholder='Πόλεις',
                  filterable, clearable)
                  el-option(v-for="city in citiesForCountry", :key="city.id", :label="city.name", :value="city")
                  el-option(label='Άλλο', value='other', key="other")
              el-card.box-card(shadow="always",
                v-show='manageCities && (!isEmptyValue(city.name) || city === "other")', v-loading='gettingCity')
                .clearfix(slot='header')
                  span() {{addModifyTextCity}} {{city.name}} της χώρας {{country.name}}
                .text.item(v-loading='savingCity')
                  el-form-item(label='Όνομα', prop='city.nameInserted')
                    el-input(placeholder='Όνομα', v-model='city.nameInserted',
                      @input="city.nameInserted = city.nameInserted.toUpperCase()")
                  // Dropdown for selecting state for city if it belongs to one
                  el-form-item(label='Πολιτεία που ανήκει', v-loading='gettingStates', v-if='city.state && country.states_exist === 1')
                    el-select(v-model='city.state', value-key="id", placeholder='Πολιτείες', filterable, clearable)
                      el-option(v-for="state in statesForCities", :key="state.id", :label="state.name", :value="state")
                  div(style='text-align: center')
                    el-button(type="primary" @click="saveNewCity" icon="el-icon-edit") Αποθήκευση Πόλης
                    el-button(type="danger" @click="deleteCity" icon="el-icon-delete") Διαγραφή Πόλης
            // States Management
            el-form-item(label="Διαχείριση Πολιτειών", v-show='!addOrModify && country.states_exist === 1')
              el-switch(v-model="manageStates", active-text="Ναι", inactive-text="Όχι", @change='manageStatesChanged')
              el-form-item(label='Επιλέξτε Πολιτεία', v-show='manageStates', v-loading='gettingStates')
                el-select.big(v-model='state' , @change="stateSelected", value-key="id", placeholder='Πολιτείες',
                  filterable, clearable)
                  el-option(v-for="state in states", :key="state.id", :label="state.name", :value="state")
                  el-option(label='Άλλο', value='other', key="other")
              el-card.box-card(shadow="always",
                v-show='manageStates && (!isEmptyValue(state.name) || state === "other")', v-loading='gettingState')
                .clearfix(slot='header')
                  span() {{addModifyTextState}} {{state.name}} της χώρας {{country.name}}
                .text.item(v-loading='savingState')
                  el-form-item(label='Όνομα', prop='state.nameInserted')
                    el-input(placeholder='Όνομα', v-model='state.nameInserted',
                      @input="state.nameInserted = state.nameInserted.toUpperCase()")
                  el-form-item(label='Συντομογραφία', prop='state.abbrv')
                    el-input(placeholder='Όνομα', v-model='state.abbrv',
                      @input="state.abbrv = state.abbrv.toUpperCase()")
                  div(style='text-align: center')
                    el-button(type="primary" @click="saveNewState" icon="el-icon-edit") Αποθήκευση Πολιτείας
                    el-button(type="danger" @click="deleteState" icon="el-icon-delete") Διαγραφή Πολιτείας
        // University Management
        br
        el-form-item(label='Πανεπιστήμιο', v-loading="gettingUniversities",
          prop="universitySelect", v-show='showAll.university && !addMeeting')
          el-select.big(v-model='universitySelect' , @change="universitySelected", value-key="id",
            placeholder='Πανεπιστήμια', :disabled="disableUniversity", filterable, clearable)
            el-option(v-for="university in universities", :key="university.id",
              :label="university.name", :value="university")
            el-option(v-show='addOrModify' label='Άλλο', value='other', key="other")
        el-card.box-card(shadow="always", v-loading='gettingUniversity',
          v-show="(university.name === 'other'|| (!addOrModify && checkboxΙnstitutions[0] === 'Πανεπιστήμιο')) && !addMeeting")
          .clearfix(slot='header')
            span(v-if='addOrModify') Εισάγετε νέο Πανεπιστήμιο για την χώρα {{country.name}}
            span(v-else) Επιλέξτε και Τροποποιήστε το Πανεπιστήμιο {{university.name}} της χώρας {{country.name}}
          .text.item(v-show="showAll.university && !isEmptyValue(university.name)")
            // Common fields (same as old universities)
            el-form-item(label='Όνομα*'  prop="university.nameInserted" v-if='addOrModify')
              el-input.big(type="text", placeholder='Όνομα',
                v-model='university.nameInserted',
                @change="universityInsertedChanged",
                @input="university.nameInserted = university.nameInserted.toUpperCase()")
            el-form-item(label='Νέο Όνομα*'  prop="university.nameInserted" v-else)
              el-input.big(type="text", placeholder='Όνομα',
                v-model='university.nameInserted',
                @change="universityInsertedChanged",
                @input="university.nameInserted = university.nameInserted.toUpperCase()")
            el-form-item(label='Προηγ. Όνομα1', prop='university.ex_name')
              el-input(placeholder='ex_name', v-model='university.ex_name',
                @input="university.ex_name = university.ex_name.toUpperCase()")
            el-form-item(label='Προηγ. Όνομα2', prop='university.ex_name1')
              el-input(placeholder='ex_name1', v-model='university.ex_name1',
                @input="university.ex_name1 = university.ex_name1.toUpperCase()")
            el-form-item(label='Παν/μιο?', prop='university.university_type_status')
              el-select(v-model='university.university_type_status', placeholder='Τύπος',
                filterable, clearable)
                el-option(label='Ναι', value='Y', key="Y")
                el-option(label='Άλλο Ίδρυμα', value='N', key="N")
                el-option(label='Επιτροπή', value='E', key="E")
            el-form-item(label='Αναγνώριση*', prop="university.sync_mitroa_recognition_status")
              el-select(v-model='university.sync_mitroa_recognition_status', placeholder='Κατάσταση', filterable, clearable
                @change="onRecognitionStatusChanged")
                el-option(label='Αναγνωρισμένο', value='recognized', key="recognized")
                el-option(label='Μη αναγνωριστέο', value='unrecognized', key="unrecognized")
                el-option(label='Μη κριθέν', value='under review', key="under_review")
            el-form-item(label='Αρ. Συνεδρίας', prop='university.meeting')
              el-select.big(v-model='university.meeting' , value-key="id", placeholder='Αριθμός Συνεδρίας', filterable)
                el-option(v-for="meeting in meetings", :key="meeting.id",
                  :label="meeting.meeting_no", :value="meeting")
            el-form-item(label='Αρ. Πράξης', prop='university.epitropi_id')
              el-input(placeholder='epitropi_id', v-model='university.epitropi_id',
                @input="university.epitropi_id = university.epitropi_id.toUpperCase()")
            el-form-item(label='Ενεργό*', prop="university.active")
              el-select(v-model='university.active', placeholder='Ενεργό', filterable, clearable)
                el-option(label='Ναι', value='Y', key="Y")
                el-option(label='Όχι', value='N', key="N")
            el-form-item(label='Τύπος', prop='university.type')
              el-select(v-model='university.type', placeholder='Τύπος', filterable, clearable)
                el-option(label='', value='', key="N")
                el-option(label='Κρατικό', value='S', key="S")
                el-option(label='Ιδιωτικό', value='P', key="P")
            el-form-item(label='Διεύθυνση', prop='university.address')
              el-input(placeholder='Διεύθυνση', v-model='university.address',
                @input="university.address = university.address.toUpperCase()")
            el-form-item(label='Πόλη', v-loading="gettingCities", prop="university.city")
              el-select(v-model='university.city', placeholder='Πόλη', :disabled="disableCities",
                @change='citySelected', value-key="id", filterable, clearable)
                el-option(v-for="cit in cities", :key="cit.id", :label="cit.name", :value="cit")
            el-form-item(label='Πολιτεία', prop='university.states')
              el-select(v-model='university.states', placeholder='Πολιτεία', :disabled="disableUniState",
                @change='uniStateSelected', value-key="id", filterable, clearable)
                el-option(v-for="state in states", :key="state.id", :label="state.name", :value="state")
            el-form-item(label='Τηλέφωνο1', prop='university.phone')
              el-input(placeholder='Αριθμός', v-model='university.phone')
            el-form-item(label='Τηλέφωνο2', prop='university.other_phone')
              el-input(placeholder='Αριθμός άλλος', v-model='university.other_phone')
            el-form-item(label='Αριθμός fax', prop='university.fax_no')
              el-input(placeholder='Αριθμός fax', v-model='university.fax_no')
            el-form-item(label='Email', prop='university.email')
              el-input(placeholder='email', v-model='university.email')
            el-form-item(label='Μη Παν/κό Ίδρυμα', prop='university.non_universities_type_id')
              el-input(placeholder='non_universities_type_id', v-model='university.non_universities_type_id',
                @input="university.non_universities_type_id = university.non_universities_type_id.toUpperCase()")
            el-form-item(label='Για Διαδίκτυο', prop='university.h_internet')
              el-input.commentText(type="textarea", placeholder='h_internet', v-model='university.h_internet',
                class="commentText", @input="university.h_internet = university.h_internet.toUpperCase()")
            el-form-item(label="Σχόλια:")
              el-input(type="textarea", class="commentText", placeholder="Εισάγετε εσωτερικό σχόλιο"
                v-model="university.comments" size="100" :autosize="{ minRows: 4, maxRows: 10 }")
            // New Institutes section (sync_mitroa_* fields)
            div.new-institutes-section
              el-form-item(label="Τύπος Ιδρύματος")
                span Νέο
              el-form-item(
                label="Δικαιόχρηση*"
                prop="university.sync_mitroa_is_parent_franchise"
              )
                el-select(
                  v-model="university.sync_mitroa_is_parent_franchise"
                  placeholder="Επιλέξτε"
                  filterable
                  clearable
                )
                  el-option(label="Ναι", :value="1", key="1")
                  el-option(label="Όχι", :value="0", key="0")
              // Full-width institute fields
              .new-institute-full-field
                label Ελληνική Ονομασία
                el-input(
                  v-model="university.sync_mitroa_institute_el"
                  placeholder="Ελληνική ονομασία"
                  @input="university.sync_mitroa_institute_el = university.sync_mitroa_institute_el.toUpperCase()"
                )
              .new-institute-full-field
                label Πρωτότυπη Ονομασία
                el-input(
                  v-model="university.sync_mitroa_institute_original"
                  placeholder="Πρωτότυπη ονομασία"
                  @input="university.sync_mitroa_institute_original = university.sync_mitroa_institute_original.toUpperCase()"
                )
              .new-institute-full-field
                label Σύνδεσμος (URL)
                el-input(
                  v-model="university.sync_mitroa_url"
                  placeholder="URL"
                )
              .new-institute-full-field
                label Πληροφορίες
                el-input(
                  type="textarea"
                  v-model="university.sync_mitroa_info"
                  placeholder="Πληροφορίες"
                  :autosize="{ minRows: 2, maxRows: 6 }"
                )
              // Previous institute titles remain inline
              el-form-item.compact-form-item(
                label="Προηγ. Τίτλος Ιδρύματος 1"
                prop="university.sync_mitroa_institute_old_1"
              )
                el-input(
                  placeholder="Προηγούμενη ονομασία 1"
                  v-model="university.sync_mitroa_institute_old_1"
                  @input="university.sync_mitroa_institute_old_1 = university.sync_mitroa_institute_old_1.toUpperCase()"
                )
              el-form-item.compact-form-item(
                label="Προηγ. Τίτλος Ιδρύματος 2"
                prop="university.sync_mitroa_institute_old_2"
              )
                el-input(
                  placeholder="Προηγούμενη ονομασία 2"
                  v-model="university.sync_mitroa_institute_old_2"
                  @input="university.sync_mitroa_institute_old_2 = university.sync_mitroa_institute_old_2.toUpperCase()"
                )
        div(style='text-align: center')
          el-button(type="primary" @click="saveNewUni" icon="el-icon-edit" :disabled='isSaveDisabled') {{saveButtonText}}
          el-button(type="danger" @click="deleteUni" icon="el-icon-delete" :disabled='disableDelete') Διαγραφή {{checkboxΙnstitutions[0]}}
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import config from '../../config.js'
import sharedMethods from '../common/sharedMethods.js'

export default {
  name: 'ManageNewInstitutes',
  props: {
    addUniversity: {type: Boolean, default: false}
  },
  mixins: [sharedMethods],
  mounted () {
    this.getMeetings()
  },
  data () {
    return {
      dsEpitropes: [
        { label: 'Διοικητικό', value: 'D', key: 'D' }
      ],
      respId: [
        { label: 'Γραμματεία Τμήμα Α', value: 107, key: 107 },
        { label: 'Γραμματεία Τμήμα B', value: 114, key: 114 }
      ],
      statesForCities: [],
      addMeeting: false,
      meeting: {meeting_no: '', id: '', nameInserted: '', meeting_date: '', ds_epitropi: 'D', resp_id: ''},
      savingState: false,
      savingCity: false,
      savingMeeting: false,
      addModifyTextCity: 'Τροποποιήστε την Πόλη',
      addModifyTextState: 'Τροποποιήστε την Πολιτεία',
      manageCities: false,
      manageStates: false,
      states_exist: false,
      universitySelect: {name: '', id: null},
      otherValue: {id: null, name: 'Άλλο', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''},
      checkboxΙnstitutions: [''],
      addOrModify: true,
      application: {},
      state: {
        id: null,
        name: '',
        nameInserted: '',
        countries_id: null,
        abbrv: null
      },
      country: {
        id: '',
        name: '',
        nameInserted: '',
        ex_name: '',
        states_exist: 0,
        short_name: ''
      },
      states: [],
      university: {
        // Common fields (same as old universities)
        id: '',
        name: '',
        nameInserted: '',
        countries_id: '',
        cities_id: '',
        city: {id: '', name: ''},
        active: 'Y',
        accredited: 'U',
        meetings_id: 0,
        comments: '',
        fax_no: '',
        other_phone: '',
        email: '',
        university_type_status: '',
        states: '',
        epitropi_id: '',
        address: '',
        phone: '',
        non_universities_type_id: '',
        h_internet: '',
        type: '',
        ex_name: '',
        ex_name1: '',
        // New fields for new institutes
        sync_mitroa_is_new_institute: 1,
        sync_mitroa_recognition_status: 'recognized',
        sync_mitroa_is_parent_franchise: 0,
        sync_mitroa_institute_el: '',
        sync_mitroa_institute_original: '',
        sync_mitroa_institute_old_1: '',
        sync_mitroa_institute_old_2: '',
        sync_mitroa_url: '',
        sync_mitroa_info: ''
      },
      deletingCity: false,
      deletingState: false,
      deletingUnit: false,
      gettingCity: false,
      gettingState: false,
      gettingStates: false,
      gettingCountry: false,
      savingCountry: false,
      gettingUniversities: false,
      gettingUniversity: false,
      gettingCities: false,
      gettingMeetings: false,
      gettingMeeting: false,
      colFacDept: {},
      disableCities: false,
      disableUniversity: true,
      disableUniState: false,
      cities: [],
      citiesForCountry: [],
      city: {id: null, name: '', nameInserted: '', state: {name: '', id: ''}},
      universities: [],
      showAll: {country: true, university: true}
    }
  },
  methods: {
    statesExistsChanged () {
      this.country.states_exist = this.states_exist ? 1 : 0
    },
    addMeetingChanged (val) {
      if (val) {
        this.showAll = {country: false, university: false}
      } else {
        this.showAll = {country: true, university: true}
      }
    },
    uniStateSelected (state) {
    },
    meetingSelected () {
      this.getMeeting()
    },
    cityForCountrySelected (val) {
      if (val !== 'other') {
        this.gettingCity = true
        this.addModifyTextCity = 'Τροποποιήστε την Πόλη'
        axios.get(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/cities/${val.id}`)
          .then((response) => {
            this.city = response.data.data
            this.$set(this.city, 'nameInserted', response.data.data.name)
            this.gettingCity = false
          }).catch(err => {
            this.gettingCity = false
            this.backendError(err)
          })
      } else {
        this.addModifyTextCity = 'Εισάγετε νέα Πόλη'
        this.city = {name: 'other', nameInserted: '', state: {name: '', id: null}}
      }
    },
    getMeetings () {
      this.gettingMeetings = true
      axios.get(`${config.BASE_URL}/meetings`)
        .then((response) => {
          this.$store.dispatch('LOAD_MEETINGS', response.data.data)
          this.meetings.unshift({id: null, meeting_no: ''})
          this.gettingMeetings = false
        }).catch(err => {
          this.gettingMeetings = false
          this.backendError(err)
        })
    },
    getMeeting () {
      this.gettingMeeting = true
      axios.get(`${config.BASE_URL}/meetings/${this.meeting.id}`)
        .then((response) => {
          this.meeting = response.data.data
          this.meeting.nameInserted = this.meeting.meeting_no
          this.gettingMeeting = false
        }).catch(err => {
          this.gettingMeeting = false
          this.backendError(err)
        })
    },
    getState (id) {
      return axios.get(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states/${id}`)
        .then((response) => {
          this.state = response.data.data
          this.$set(this.state, 'nameInserted', response.data.data.name)
          this.gettingState = false
        }).catch(err => {
          this.gettingState = false
          this.backendError(err)
        })
    },
    getStates () {
      this.gettingStates = true
      return axios.get(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states`)
        .then((response) => {
          this.states = response.data.data
          this.gettingStates = false
          return response
        }).catch(err => {
          this.gettingStates = false
          this.backendError(err)
          throw err
        })
    },
    stateSelected (val) {
      if (val !== 'other') {
        this.gettingState = true
        this.addModifyTextState = 'Τροποποιήστε την Πολιτεία'
        axios.get(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states/${val.id}`)
          .then((response) => {
            this.state = response.data.data
            this.$set(this.state, 'nameInserted', response.data.data.name)
            this.gettingState = false
          }).catch(err => {
            this.gettingState = false
            this.backendError(err)
          })
      } else {
        this.addModifyTextState = 'Εισάγετε νέα Πολιτεία'
        this.state = {name: 'other', nameInserted: '', abbrv: ''}
      }
    },
    getCities () {
      this.gettingCities = true
      return axios.get(`${config.BASE_URL}/countries/${this.country.id}/cities`)
        .then((response) => {
          this.gettingCities = false
          return response
        }).catch(err => {
          this.gettingCities = false
          this.backendError(err)
          throw err
        })
    },
    manageCitiesChanged (manage) {
      if (manage) {
        this.getCities().then((response) => {
          this.citiesForCountry = response.data.data
          this.gettingCities = false
        }).catch(err => {
          this.citiesForCountry = []
          this.gettingCities = false
          console.log(err)
        })
        if (this.country.states_exist === 1) {
          this.getStates().then((response) => {
            this.statesForCities = response.data.data
            this.gettingStates = false
          }).catch(err => {
            this.statesForCities = []
            this.gettingStates = false
            console.log(err)
          })
        }
      }
    },
    manageStatesChanged () {
      this.getStates().then((response) => {
        this.states = response.data.data
        this.gettingStates = false
      })
    },
    getCountries () {
      this.$store.dispatch('LOAD_COUNTRIES')
    },
    hideForm () {
      this.initializeUniversity()
      this.$emit('hideForm')
    },
    initializeUniversity () {
      Object.keys(this.university).forEach(key => { this.university[key] = '' })
      this.university.countries_id = this.country.id
      this.university.cities_id = null
      delete this.university.meeting
      delete this.university.greek_countries_id
      delete this.university.states_id
      this.university.id = null
      this.universitySelect = {name: '', id: null}
      this.university.accredited = 'U'
      this.university.active = 'Y'
      // Reset new fields
      this.university.sync_mitroa_is_new_institute = 1
      this.university.sync_mitroa_recognition_status = 'under review'
      this.university.sync_mitroa_is_parent_franchise = 0
      this.university.sync_mitroa_institute_el = ''
      this.university.sync_mitroa_institute_original = ''
      this.university.sync_mitroa_institute_old_1 = ''
      this.university.sync_mitroa_institute_old_2 = ''
      this.university.sync_mitroa_url = ''
      this.university.sync_mitroa_info = ''
    },
    groupChanged (data) {
      this.addMeeting = false
      this.manageStates = false
      this.state = { id: null, name: '', countries_id: null, abbrv: null }
      this.manageCities = false
      this.city = { id: null, name: '', state: {name: '', id: ''} }
      this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
      this.universitySelect = {name: '', id: null}
      this.university.name = ''
      this.university.id = null
      let temp = this.checkboxΙnstitutions[this.checkboxΙnstitutions.length - 1]
      this.checkboxΙnstitutions = []
      this.checkboxΙnstitutions.push(temp)
      switch (this.checkboxΙnstitutions[0]) {
        case 'Χώρα':
          this.showAll = {country: true, university: false}
          break
        case 'Πανεπιστήμιο':
          this.showAll = {country: true, university: true}
          break
        case 'Συνεδρία':
          this.showAll = {country: false, university: false}
          this.addMeeting = true
          break
      }
    },
    calcAccreditedValue (val) {
      switch (val) {
        case 'R':
          return 'Αναγνωρισμένο'
        case 'N':
          return 'Μη αναγνωρισμένο'
        case 'U':
          return 'Μη κριθέν'
      }
    },
    calcActiveValue (val) {
      return val ? 'Ναι' : 'Όχι'
    },
    addConfirmMessage () {
      let missingRequired = false
      let message = `Στην χώρα: ${this.country.name} ${this.addOrModify ? ' θα προσθέσετε ' : ' θα τροποποιήσετε '}`
      if (this.university.name === 'other' || (!this.addOrModify && this.checkboxΙnstitutions[0] === 'Πανεπιστήμιο')) {
        if (this.university.nameInserted === '' || this.university.city.name === '' ||
        this.university.active === '' || this.university.sync_mitroa_recognition_status === '') {
          missingRequired = true
          message = ''
          message = 'Παρακαλώ συμπληρώστε σωστά όλα τα πεδία με αστερίσκο για το Πανεπιστήμιο. '
        } else {
          missingRequired = false
          message += 'το Πανεπιστήμιο: ' + this.university.nameInserted + ',' +
          ' που είναι στην πόλη: ' + this.university.city.name + ',' +
          ' που είναι ενεργό: ' + this.calcActiveValue(this.university.active) + ',' +
          ' και αναγνωρισμένο: ' + this.university.sync_mitroa_recognition_status + ',' +
          ' με αριθμό συνεδρίας: ' +
          (this.university.meeting && !this.isEmptyValue(this.university.meeting.id) ? this.university.meeting.meeting_no : '--') + ','
        }
      } else {
        message += 'στο υπάρχον Πανεπιστήμιο: ' + this.university.name + ','
      }
      return {message: message, missingRequired: missingRequired}
    },
    deleteState () {
      this.deletingState = true
      this.$confirm(`Προσοχή! Θα διαγράψετε την Πολιτεία ${this.state.name} αν δεν έχει πόλεις`, 'Προειδοποίηση', {
        confirmButtonText: 'Διαγραφή',
        cancelButtonText: 'Άκυρο',
        type: 'warning'
      }).then(() => {
        axios.delete(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states/${this.state.id}`)
          .then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η διαγραφή ολοκληρώθηκε επιτυχώς')
            this.deletingState = false
          }).catch((err) => {
            this.deletingState = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την διαγραφή')
            this.backendError(err)
          })
      }).catch((err) => {
        console.log(err)
        this.$message({
          type: 'info',
          message: 'Η διαγραφή ματαιώθηκε'
        })
      })
    },
    deleteCity () {
      this.deletingCity = true
      this.$confirm(`Προσοχή! Θα διαγράψετε την Πόλη ${this.city.name} αν δεν έχει Πανεπιστήμια`, 'Προειδοποίηση', {
        confirmButtonText: 'Διαγραφή',
        cancelButtonText: 'Άκυρο',
        type: 'warning'
      }).then(() => {
        axios.delete(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/cities/${this.city.id}`)
          .then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η διαγραφή ολοκληρώθηκε επιτυχώς')
            this.deletingCity = false
            this.city = { id: null, name: '', state: {name: '', id: ''} }
            this.getCities().then((response) => {
              this.citiesForCountry = response.data.data
              this.gettingCities = false
            })
          }).catch((err) => {
            this.deletingCity = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την διαγραφή')
            this.backendError(err)
          })
      }).catch((err) => {
        console.log(err)
        this.$message({
          type: 'info',
          message: 'Η διαγραφή ματαιώθηκε'
        })
      })
    },
    deleteUni () {
      let deleteUnitId = null
      let deleteUrl = ''
      let confirmMessage = `ΠΡΟΣΟΧΗ! Θα διαγράψετε `
      let cannotDelete = false
      switch (this.checkboxΙnstitutions[0]) {
        case 'Χώρα':
          if (!this.isEmptyValue(this.country.id)) {
            deleteUnitId = this.country.id
            deleteUrl = 'countries'
            confirmMessage += `την Χώρα ${this.country.name}`
          } else {
            cannotDelete = true
          }
          break
        case 'Πανεπιστήμιο':
          if (!this.isEmptyValue(this.university.id)) {
            deleteUnitId = this.university.id
            deleteUrl = 'uni'
            confirmMessage += `το Πανεπιστήμιο ${this.university.name}`
          } else {
            cannotDelete = true
          }
          break
        case 'Συνεδρία':
          if (!this.isEmptyValue(this.meeting.id)) {
            deleteUnitId = this.meeting.id
            deleteUrl = 'meetings'
            confirmMessage += `την συνεδρία ${this.meeting.meeting_no}`
          } else {
            cannotDelete = true
          }
          break
      }
      confirmMessage += `. Η διαγραφή θα γίνει μόνο αν δεν υπάρχει σύνδεση με υπάρχουσες πράξεις!`
      if (!cannotDelete) {
        this.$confirm(confirmMessage, 'Προειδοποίηση', {
          confirmButtonText: 'Διαγραφή',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
          this.deletingUnit = true
          axios.delete(`${this.BASE_URL}/admins/userId/${deleteUrl}/${deleteUnitId}`)
            .then((response) => {
              this.notifyUser('success', 'Επιτυχία', 'Η διαγραφή ολοκληρώθηκε επιτυχώς')
              this.deletingUnit = false
              if (deleteUrl === 'meetings') {
                this.meeting = {meeting_no: '', id: '', nameInserted: '', meeting_date: '', ds_epitropi: 'D', resp_id: ''}
                this.getMeetings()
              }
              if (deleteUrl === 'countries') { this.getCountries() }
              this.initializeUniversity()
              this.countryInsertedChanged()
              this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
              this.universitySelect = {name: '', id: null}
              this.disableUniversity = true
            }).catch((err) => {
              this.deletingUnit = false
              this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την διαγραφή')
              this.backendError(err)
            })
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'info',
            message: 'Η διαγραφή ματαιώθηκε'
          })
        })
      } else {
        this.notifyUser('error', 'Αποτυχία', 'Δεν έχετε επιλέξει τη δομή προς διαγραφή')
      }
    },
    saveNewCity () {
      if (this.city.name !== 'other') {
        this.$confirm(`Θα αποθηκεύσετε τις αλλαγές στην Πόλη ${this.city.name}`, 'Προειδοποίηση', {
          confirmButtonText: 'Αποθήκευση',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
          this.savingCity = true
          axios.put(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/cities/${this.city.id}`,
            {
              city: {
                name: this.city.nameInserted,
                state: this.country.states_exist === 1 && !this.isEmptyValue(this.city.state.id)
                  ? this.city.state
                  : null
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.savingCity = false
            this.getCities().then((response) => {
              this.citiesForCountry = response.data.data
              this.gettingCities = false
            })
          }).catch((err) => {
            this.savingCity = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.backendError(err)
          })
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'info',
            message: 'Η αποθήκευση ματαιώθηκε'
          })
        })
      } else {
        this.$confirm(`Θα εισάγετε την Πόλη ${this.city.nameInserted}`, 'Προειδοποίηση', {
          confirmButtonText: 'Αποθήκευση',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
          this.savingCity = true
          axios.post(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/cities`,
            {
              city: {
                name: this.city.nameInserted,
                state: this.country.states_exist === 1 && !this.isEmptyValue(this.city.state.id)
                  ? {name: this.city.state.name, id: this.city.state.id}
                  : null
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η εισαγωγή ολοκληρώθηκε επιτυχώς')
            this.savingCity = false
            this.getCities().then(response => { this.citiesForCountry = response.data.data })
          }).catch((err) => {
            this.savingCity = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την εισαγωγή')
            this.backendError(err)
          })
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'info',
            message: 'Η εισαγωγή ματαιώθηκε'
          })
        })
      }
    },
    saveNewState () {
      if (this.state.name !== 'other') {
        this.$confirm(`Θα αποθηκεύσετε τις αλλαγές στην Πολιτεία ${this.state.name}`, 'Προειδοποίηση', {
          confirmButtonText: 'Αποθήκευση',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
          this.savingState = true
          axios.put(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states/${this.state.id}`,
            {
              state: {
                name: this.state.nameInserted,
                abbrv: this.state.abbrv
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.getStates().then((response) => {
              this.states = response.data.data
              this.savingState = false
            })
          }).catch((err) => {
            this.savingState = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.backendError(err)
          })
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'info',
            message: 'Η αποθήκευση ματαιώθηκε'
          })
        })
      } else {
        this.savingState = true
        this.$confirm(`Θα εισάγετε την Πολιτεία ${this.state.nameInserted}`, 'Προειδοποίηση', {
          confirmButtonText: 'Αποθήκευση',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
          axios.post(`${config.BASE_URL}/admins/userId/countries/${this.country.id}/states`,
            {
              state: {
                name: this.state.nameInserted,
                abbrv: this.state.abbrv
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η εισαγωγή ολοκληρώθηκε επιτυχώς')
            this.savingState = false
          }).catch((err) => {
            this.savingState = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την εισαγωγή')
            this.backendError(err)
          })
        }).catch((err) => {
          console.log(err)
          this.$message({
            type: 'info',
            message: 'Η εισαγωγή ματαιώθηκε'
          })
        })
      }
    },
    onRecognitionStatusChanged () {
      // Keep accredited in sync with recognition_status
      this.university.accredited = this.mapRecognitionStatusToAccredited(this.university.sync_mitroa_recognition_status)
    },
    saveNewUni () {
      let confirmMessage = {}
      if (this.addOrModify) {
        if (this.addMeeting) {
          this.savingMeeting = true
          axios.post(`${this.BASE_URL}/admins/userId/meetings`,
            {
              meeting: {
                meeting_no: this.meeting.nameInserted,
                meeting_date: this.meeting.meeting_date,
                ds_epitropi: this.meeting.ds_epitropi,
                resp_id: this.meeting.resp_id
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.savingMeeting = false
            this.getMeetings()
            this.meeting = {meeting_no: '', id: '', nameInserted: '', meeting_date: '', ds_epitropi: 'D', resp_id: ''}
          }).catch((err) => {
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.savingMeeting = false
            this.backendError(err)
          })
        } else if (this.country.name === 'Άλλο') {
          // POST to add new country
          let tempCountry = {...this.country}
          tempCountry.name = tempCountry.nameInserted
          tempCountry.states_exist = this.states_exist ? 1 : 0
          delete tempCountry.id
          delete tempCountry.nameInserted
          axios.post(`${this.BASE_URL}/admins/userId/countries`,
            {
              country: tempCountry
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.getCountries()
          }).catch((err) => {
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.backendError(err)
          })
        } else if (this.university.name === null) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Παρακαλώ συμπληρώστε όλα τα πεδία Πανεπιστήμιο.',
            offset: 300
          })
        } else {
          confirmMessage = this.addConfirmMessage()
          this.$confirm(confirmMessage.message, 'Προειδοποίηση', {
            confirmButtonText: 'Αποθήκευση',
            cancelButtonText: 'Άκυρο',
            type: 'warning'
          }).then(() => {
            if (!confirmMessage.missingRequired) {
              let uni = {...this.university}
              // Map sync_mitroa_recognition_status to accredited
              uni.accredited = this.mapRecognitionStatusToAccredited(uni.sync_mitroa_recognition_status)
              // Ensure sync_mitroa_is_new_institute is always 1
              uni.sync_mitroa_is_new_institute = 1
              // Ensure sync_mitroa_is_parent_franchise is 0 or 1
              uni.sync_mitroa_is_parent_franchise = uni.sync_mitroa_is_parent_franchise ? 1 : 0
              if (uni.name === 'other') {
                uni.name = uni.nameInserted
                if (uni.meeting) {
                  uni.meetings_id = uni.meeting.id
                  delete uni.meeting
                }
              }
              if (uni.state) {
                uni.states = uni.state.id
              }
              delete uni.state
              delete uni.nameInserted
              if (uni.city) {
                uni.cities_id = uni.city.id
              } else {
                uni.cities_id = ''
              }
              delete uni.city
              uni.ex_name = uni.ex_name1
              // Special processing
              delete uni.id
              delete uni.accredited
              if (!uni.meetings_id) {
                uni.meetings_id = null
              }
              // POST to create new university
              axios.post(`${this.BASE_URL}/admins/userId/university`,
                {
                  university: uni
                }
              ).then((response) => {
                this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
                this.initializeUniversity()
                this.countryInsertedChanged()
                this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
                this.universitySelect = {name: '', id: null}
                this.disableUniversity = true
              }).catch((err) => {
                this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
                this.backendError(err)
              })
            }
          }).catch((err) => {
            console.log(err)
            this.$message({
              type: 'info',
              message: 'Η αποθήκευση ματαιώθηκε'
            })
          })
        }
      } else {
        if (this.checkboxΙnstitutions[0] === 'Συνεδρία') {
          this.savingMeeting = true
          axios.put(`${this.BASE_URL}/admins/userId/meetings/${this.meeting.id}`,
            {
              meeting: {
                meeting_no: this.meeting.nameInserted,
                meeting_date: this.meeting.meeting_date,
                ds_epitropi: this.meeting.ds_epitropi,
                resp_id: this.meeting.resp_id
              }
            }
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.savingMeeting = false
            this.getMeetings()
            this.meeting = {meeting_no: '', id: '', nameInserted: '', meeting_date: '', ds_epitropi: 'D', resp_id: ''}
          }).catch((err) => {
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.savingMeeting = false
            this.backendError(err)
          })
        } else if (this.checkboxΙnstitutions[0] === 'Χώρα') {
          // PUT to change existing country
          let tempCountry = {...this.country}
          tempCountry.name = tempCountry.nameInserted
          tempCountry.states_exist = this.states_exist ? 1 : 0
          delete tempCountry.id
          delete tempCountry.nameInserted
          this.savingCountry = true
          axios.put(
            `${this.BASE_URL}/admins/userId/countries/${this.country.id}`,
            {country: tempCountry}
          ).then((response) => {
            this.notifyUser('success', 'Επιτυχία', 'Η αποθήκευση ολοκληρώθηκε επιτυχώς')
            this.savingCountry = false
            this.getCountries()
          }).catch((err) => {
            this.savingCountry = false
            this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την αποθήκευση')
            this.backendError(err)
          })
        } else if (this.university.name === 'other') {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Δεν μπορείτε να προσθέσετε αν δεν επιλέξετε Προσθήκη και όχι Τροποποίηση',
            offset: 300
          })
        } else if ((this.isEmptyValue(this.university.name) && this.checkboxΙnstitutions[0] === 'Πανεπιστήμιο')) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Δεν έχετε επιλέξει τη δομή προς τροποποίηση.',
            offset: 300
          })
        } else {
          confirmMessage = this.addConfirmMessage()
          this.$confirm(confirmMessage.message, 'Προειδοποίηση', {
            confirmButtonText: 'Αποθήκευση',
            cancelButtonText: 'Άκυρο',
            type: 'warning'
          }).then(() => {
            if (!confirmMessage.missingRequired) {
              let putUnit = {}
              let putUrl = ''
              if (this.checkboxΙnstitutions[0] === 'Πανεπιστήμιο') {
                let uni = {...this.university}
                uni.name = uni.nameInserted
                delete uni.nameInserted
                // Map sync_mitroa_recognition_status to accredited
                uni.accredited = this.mapRecognitionStatusToAccredited(uni.sync_mitroa_recognition_status)
                // Ensure sync_mitroa_is_new_institute is always 1
                uni.sync_mitroa_is_new_institute = 1
                // Ensure sync_mitroa_is_parent_franchise is 0 or 1
                uni.sync_mitroa_is_parent_franchise = uni.sync_mitroa_is_parent_franchise ? 1 : 0
                uni.states = uni.state ? uni.state.id : null
                delete uni.state
                uni.cities_id = uni.city ? uni.city.id : null
                delete uni.city
                uni.meetings_id = uni.meeting ? uni.meeting.id : null
                delete uni.meeting
                putUnit = { university: uni }
                putUrl = 'uni'
              }
              // PUT to modify existing university
              axios.put(
                `${this.BASE_URL}/admins/userId/${putUrl}`,
                putUnit
              ).then((response) => {
                this.notifyUser('success', 'Επιτυχία', 'Η τροποποίηση ολοκληρώθηκε επιτυχώς')
                this.initializeUniversity()
                this.countryInsertedChanged()
                this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
                this.universitySelect = {name: '', id: null}
                this.disableUniversity = true
              }).catch((err) => {
                this.notifyUser('error', 'Αποτυχία', 'Παρουσιάστηκε σφάλμα κατά την τροποποίηση')
                this.backendError(err)
              })
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: 'Η τροποποίηση ματαιώθηκε'
            })
          })
        }
      }
    },
    mapRecognitionStatusToAccredited (status) {
      // Map sync_mitroa_recognition_status to accredited (R/N/U)
      switch (status) {
        case 'recognized':
          return 'R'
        case 'unrecognized':
          return 'N'
        case 'under review':
          return 'U'
        default:
          return 'U'
      }
    },
    isEmptyValue (val) {
      return !(val !== null && val !== undefined && val !== '')
    },
    notifyUser (type, title, msg) {
      if (type === 'success') {
        this.$notify.success({
          title: title,
          message: msg
        })
      } else {
        this.$notify.error({
          title: title,
          message: msg
        })
      }
    },
    addOrModifyChanged () {
      this.addMeeting = false
      this.manageStates = false
      this.state = { id: null, name: '', countries_id: null, abbrv: null }
      this.manageCities = false
      this.city = { id: null, name: '', countries_id: null, state: {name: '', id: ''} }
      this.initializeUniversity()
      this.checkboxΙnstitutions = []
      this.country = {id: '', name: '', nameInserted: '', ex_name: '', states_exist: 0, short_name: ''}
      this.university.name = ''
      this.university.id = null
      this.university.nameInserted = ''
      this.universitySelect = {name: '', id: null}
      this.disableUniversity = true
      if (this.addOrModify) {
        this.showAll = {country: true, university: true}
      } else {
        this.showAll = {country: false, university: false}
      }
    },
    countryInsertedChanged () {
      this.universities = []
    },
    universityInsertedChanged () {
    },
    citySelected (city) {
      this.university.cities_id = city.id
    },
    countrySelected (country, val) {
      this.manageStates = false
      this.state = { id: null, name: '', countries_id: null, abbrv: null }
      this.manageCities = false
      this.city = { id: null, name: '', countries_id: null, state: {name: '', id: ''} }
      this.disableUniversity = false
      // For modification
      if (!this.addOrModify && this.checkboxΙnstitutions[0] === 'Χώρα') {
        this.gettingCountry = true
        axios.get(`${config.BASE_URL}/admins/userid/countries/${country.id}`)
          .then((response) => {
            this.gettingCountry = false
            this.country = response.data.data
            this.$set(this.country, 'nameInserted', response.data.data.name)
          }).catch(err => {
            this.gettingCountry = false
            this.backendError(err)
          })
      } else {
        this.university.id = null
        this.university.name = null
        this.university.nameInserted = ''
        this.initializeUniversity()
        this.disableUniversity = false
        // If existing country selected
        if (country.name !== 'Άλλο') {
          if (this.addOrModify) {
            this.showAll = {country: true, university: true}
          }
          if (country) {
            this.city = {id: null, name: ''}
            // Fetch cities for country
            this.getCities().then(response => { this.cities = response.data.data })
            this.gettingUniversities = true
            this.universities = []
            // Fetch universities for country and filter for new institutes only
            axios.get(`${config.BASE_URL}/countries/${country.id}/universities`)
              .then((response) => {
                this.universities = response.data.data.filter(u => u.is_new_institute === 1)
                this.gettingUniversities = false
              }).catch(err => {
                this.gettingUniversities = false
                this.backendError(err)
                this.universities = []
              })
          } else {
            this.disableUniversity = true
            this.universities = []
          }
        } else {
          this.showAll = {country: true, university: false}
        }
      }
    },
    universitySelected (university) {
      this.initializeUniversity()
      this.university.nameInserted = ''
      if (university !== 'other') {
        this.universitySelect = {name: university.name, id: university.id}
        this.university.name = university.name
        this.university.id = university.id
        // If modify, fetch selected university details
        if (!this.addOrModify) {
          this.gettingUniversity = true
          axios.get(`${config.BASE_URL}/universities/${university.id}`)
            .then((response) => {
              this.university = response.data.data[0]
              this.$set(this.university, 'nameInserted', response.data.data[0].name)
              // Map accredited to sync_mitroa_recognition_status
              if (this.university.accredited) {
                this.university.sync_mitroa_recognition_status = this.mapAccreditedToRecognitionStatus(this.university.accredited)
              }
              this.gettingUniversity = false
            }).catch(err => {
              this.backendError(err)
              this.gettingUniversity = false
            })
        }
      } else {
        this.getStates()
        this.university.name = university
        this.university.id = null
        this.universitySelect = university
        if (!this.addOrModify) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: 'Για να εισάγετε νέο Πανεπιστήμιο επιλέξτε Προσθήκη και όχι Τροποποίηση',
            offset: 300
          })
        }
      }
    },
    mapAccreditedToRecognitionStatus (accredited) {
      // Map accredited (R/N/U) to sync_mitroa_recognition_status
      switch (accredited) {
        case 'R':
          return 'recognized'
        case 'N':
          return 'unrecognized'
        case 'U':
          return 'under review'
        default:
          return 'under review'
      }
    }
  },
  computed: {
    institutions () {
      return this.activeRole !== 'RegistryAdmin'
        ? ['Χώρα', 'Πανεπιστήμιο', 'Συνεδρία']
        : ['Πανεπιστήμιο', 'Συνεδρία']
    },
    hasSelectedManageableItem () {
      if (this.addOrModify) {
        return false
      }

      switch (this.checkboxΙnstitutions[0]) {
        case 'Χώρα':
          return !this.gettingCountry && !this.isEmptyValue(this.country.id)

        case 'Πανεπιστήμιο':
          return !this.gettingUniversity && !this.isEmptyValue(this.university.id)

        case 'Συνεδρία':
          return !this.gettingMeeting && !this.isEmptyValue(this.meeting.id)

        default:
          return false
      }
    },
    isSaveDisabled () {
      // Modification requires a selected item whose details have finished loading.
      if (!this.addOrModify) {
        return !this.hasSelectedManageableItem
      }

      // Insertion is allowed only for a new meeting, country, or university.
      return !(
        this.addMeeting ||
        this.country.name === 'Άλλο' ||
        this.university.name === 'other'
      )
    },
    disableDelete () {
      // Deletion is possible only in modification mode and after an item is selected.
      return !this.hasSelectedManageableItem
    },
    saveButtonText () {
      return this.addOrModify ? 'Εισαγωγή' : 'Τροποποίηση'
    },
    ...mapGetters(['activeRole']),
    ...mapState([
      'searchVisible',
      'searchForeignVisible',
      'internalUsers',
      'BASE_URL',
      'countries',
      'meetings',
      'academicAreas',
      'countries',
      'gettingCountries'
    ])
  },
  watch: {
    country: {
      handler: function (newVal, oldVal) {
        this.states_exist = !!newVal.states_exist
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.commentText {
  width: 320px;
}
.el-select {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 1100px;
  }
  &.countries {
    width: 440px;
  }
}
.el-input {
  &.big {
    width: 440px;
  }
  &.biggest {
    width: 540px;
  }
}
.list-group {
  min-height: 20px;
}

.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}

//- New institutes
.new-institutes-section {
  display: block;
  width: 100%;
  margin: 18px 0;
  padding: 18px;
  box-sizing: border-box;
  overflow: hidden;

  border: 1px solid #b9d4e8;
  border-left: 4px solid #409eff;
  border-radius: 6px;
  background-color: #f0f7fc;
}

.new-institute-full-field {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin: 0 0 18px 0;
  box-sizing: border-box;
}

.new-institute-full-field > label {
  flex: 0 0 130px;
  padding: 0 12px 0 0;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  box-sizing: border-box;
}

.new-institute-full-field > .el-input,
.new-institute-full-field > .el-textarea {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
}

.new-institute-full-field .el-input__inner,
.new-institute-full-field .el-textarea__inner {
  width: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/ManageNewInstitutes.vue